import CodesTextCopyFields from './CodesTextCopyField';

export default CodesTextCopyFields;
